import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { AddConsultationDto, QuestionnaireQuestionDto } from '../../models/account/account.models';
import { AccountService } from '../../services/account.service';

@Component({
    selector: 'questionnaire',
    template: require('./questionnaire.component.html')
})
export class QuestionnaireComponent implements OnInit {
    
    userId: number;
    questions: QuestionnaireQuestionDto[];

    constructor(private readonly accountService: AccountService,
        loggedInUserService: LoggedInUserService,
        private readonly router: Router
    ) {

        var user = loggedInUserService.getCurrentUser();
        this.userId = user.userId;

    }

    ngOnInit() {
        this.getQuestionnaireQuestions();
    }

    getQuestionnaireQuestions() {
        this.accountService.getQuestionnaireQuestions().subscribe((response: QuestionnaireQuestionDto[]) => {
            this.questions = response;
        });
    }

    save() {
        this.accountService.submitQuestionnaire(this.questions).subscribe(() => {
            this.router.navigateByUrl('/tenders/mymatches');
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/questionnaire.component.ts